<template>
  <div id="TablePrint" class="print">
    <!-- <div class="header">
      <div class="logo mb-1 flex align-center space-between">
        <img src="@/assets/logo.png" alt="logo" />
        <img src="@/assets/medi.png" alt="logo" />
      </div>
    </div> -->
    <div class="invoice">
      <div class="flex justify-center" v-if="token && token.length > 0">
        <div
          class="token mr-1"
          v-for="(item, index) in token"
          :key="index + item"
        >
          <p>
            {{ item.name }}: <strong>{{ item.token }}</strong>
          </p>
        </div>
      </div>
      <div class="details flex space-between">
        <div class="user-details">
          <h2>Name: {{ userData.name }}</h2>
          <h2>Age: {{ userData.age ? userData.age : "" }}</h2>
          <h2 v-if="userData.refferedTo">
            Referred to: {{ userData.refferedTo }}
          </h2>
        </div>
        <div class="user-details">
          <h2>F/H Name: {{ userData.fatherHusband }}</h2>
          <h2>Invoice No: {{ invoiceNo }}</h2>
        </div>
        <div class="user-details">
          <h2>MR: {{ userData.mrNo }}</h2>
          <h2>Bill Date: {{ currentDate }}</h2>
        </div>
      </div>
      <div class="invoiceTable">
        <charges-table :cols="serviceColumns" :rows="rows"> </charges-table>
      </div>
      <div class="total">
        <div v-if="discount" class="discount flex align-center justify-end">
          <h2 class="mr-2">Discount:</h2>
          <h2>{{ discount.toLocaleString() }}</h2>
        </div>
        <div class="discount flex align-center justify-end">
          <h2 class="mr-2">Total:</h2>
          <h2>{{ total.toLocaleString() }}</h2>
        </div>
      </div>
      <div class="footer">
        <p class="text-center">
          <!-- رپورٹ تیار ہوتے ہی آپ کے موبائل نمبر پر اطلاع دی جاے گی ۔ -->
        </p>
        <p class="text-center note">
          <!-- A text message will be sent on your registered mobile number when
          report is ready. You can view and download report or visit with
          original receipt to collect the report. -->
        </p>
        <p class="text-center">
          Printed by {{ user && user.employ && user.employ.full_name }} on
          {{ printedOn }}
        </p>
        <p class="text-center">
          Powered by uConnect Technologies
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ChargesTable from "@/components/ChargesTable";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    ChargesTable
  },
  props: {
    rows: {
      type: Array
    },
    discount: {
      type: Number
    },
    total: {
      type: Number
    },
    token: {
      type: Array
    },
    refferedTo: {
      type: String
    },
    registerPatient: {
      type: Object
    },
    invoiceNo: {
      type: Number
    }
  },
  data() {
    return {
      serviceColumns: [
        { column: "serial", label: "#", width: "60" },
        { column: "name", label: "Service Charges" },
        { column: "price", label: "Price" },
        { column: "subtotal", label: "Sub Total" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/userInfo"
    }),
    currentDate() {
      return moment().format("MM/DD/YYYY, h:mm:ss A");
    },
    userData() {
      const patient = this.registerPatient || {};
      const user = {
        name: patient.name,
        mrNo: patient.mr_no,
        age: patient.age,
        fatherHusband: patient.fatherOrHusbandName
      };
      return user;
    },
    printedOn() {
      return moment().format("dddd, MMMM Do, YYYY");
    }
  }
};
</script>

<style>
@media print {
  body {
    font-family: "Nunito Sans", sans-serif;
    font-size: 14pt;
    margin: 0;
    padding: 0;
  }
  .header {
    border-bottom: 1px solid hsl(0, 0%, 82%);
  }
  .header .logo {
    margin-bottom: 14pt;
  }
  .discount h2 {
    margin: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 8pt;
    letter-spacing: 0.05em;
    text-transform: capitalize;
    color: #141414;
  }
  .token p {
    font-size: 8pt;
    margin: 0;
    margin-top: 10px;
  }
  .token span {
    font-style: normal;
    font-weight: 500 !important;
    font-size: 8pt !important;
    line-height: 35px;
    color: #3e3e3e;
  }
  .footer p {
    margin: 0;
    font-size: 8pt;
  }
  .footer .note {
    font-size: 8pt;
  }
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
    font-family: "Nunito Sans", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 9pt;
    line-height: 25px;
    color: #000000;
  }
  .details {
    padding: 10px 0 10px 0;
  }
  .details h2 {
    margin-top: -8px;
  }
  /** Setting margins */

  @page {
    margin: 2cm;
  }
  .table span {
    font-size: 8pt !important;
  }
  .table {
    min-height: 0;
  }
  .table tbody tr {
    border-bottom: 1px solid #ebebeb !important;
  }
  .table tbody tr {
    border-top: 1px solid #ebebeb !important;
  }
  .table table tr th:first-child {
    padding-bottom: none;
  }
  .table table tr th {
    padding: 0 !important;
  }
  .table table tr td {
    padding: 0 !important;
  }
}
</style>
